import PieChart, { Legend } from "components/pie-chart";
import * as React from 'react';
export default {
  PieChart,
  Legend,
  React
};